document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      target?.toggleAttribute('hidden', expanded);
    });
  });

  document.querySelectorAll('[data-cart-quantity]').forEach((input) => {
    input.addEventListener('change', () => input.form?.submit());
  });

  document.querySelectorAll('[data-conditional-select]').forEach((select) => {
    if (!(select instanceof HTMLSelectElement)) return;
    const key = select.getAttribute('data-conditional-select');
    const sync = () => {
      const enabled = select.value === 'نعم';
      document.querySelectorAll(`[data-conditional="${key}"]`).forEach((target) => {
        target.toggleAttribute('hidden', !enabled);
        target.querySelectorAll('input, textarea, select').forEach((control) => {
          if (!(control instanceof HTMLInputElement || control instanceof HTMLTextAreaElement || control instanceof HTMLSelectElement)) return;
          const required = control.hasAttribute('data-conditional-required');
          control.disabled = !enabled;
          control.required = enabled && required;
          if (!enabled) control.value = '';
        });
      });
    };
    sync();
    select.addEventListener('change', sync);
  });
});
